/**
 * Atmosphere — long, sparse sustained tones floating above the harmony.
 * Unlike the pad (block chords), atmosphere voices a single chord tone at
 * a time with very long bows, occasionally shimmering up an octave.
 */
export class AtmospherePatternStrategy {
  generate(ctx, chord, oct, baseDegree, rand, bpb) {
    const pattern = [];

    // Roughly every other bar stays silent — space is the point
    if (rand() < 0.45) return pattern;

    // One long tone on a chord color note (prefer 3rd/5th over root)
    const idx = chord.length > 2 && rand() < 0.6 ? (rand() < 0.5 ? 1 : 2) : 0;
    pattern.push({
      beat: rand() * 0.5,
      note: ctx.noteFromSemitone(chord[idx % chord.length], oct),
      duration: bpb * ctx.beatDuration * (1.2 + rand() * 1.2),
    });

    // Occasional octave shimmer answering late in the bar
    if (rand() < 0.3) {
      pattern.push({
        beat: bpb * (0.5 + rand() * 0.25),
        note: ctx.noteFromSemitone(chord[0] + 12, oct),
        duration: bpb * ctx.beatDuration * (0.8 + rand() * 0.6),
      });
    }

    return pattern;
  }
}
